import { useState, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("ma-cookie-consent");
    if (!consent) {
      const t = setTimeout(() => setShow(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem("ma-cookie-consent", "accepted");
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="cookie-banner"
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ ease: [0.16, 1, 0.3, 1], duration: 0.6 }}
          className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-md z-[60] rounded-2xl bg-ink text-white p-6 border border-gold/25 shadow-2xl"
        >
          <div className="flex items-start gap-3 mb-3">
            <Cookie className="text-gold shrink-0" size={22} />
            <p className="text-sm text-white/70 leading-relaxed">
              Wir verwenden nur technisch notwendige Cookies, um die Website bereitzustellen.
              Mehr dazu in der <Link to="/datenschutz" className="text-gold underline underline-offset-2">Datenschutzerklärung</Link>.
            </p>
          </div>
          <button
            onClick={accept}
            data-testid="cookie-accept"
            className="w-full rounded-full bg-gold px-5 py-2.5 text-sm font-medium text-ink hover:bg-gold-light transition-colors"
          >
            Verstanden
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
